export function throttle(fn, delay) {
    let timeout = null;
    let lastArgs = null;
    const trigger = (...args) => {
        if (timeout === null) {
            lastArgs = null;
            timeout = setTimeout(() => {
                timeout = null;
                if (lastArgs)
                    trigger(...lastArgs);
            }, delay);
            fn(...args);
        }
        else {
            lastArgs = args;
        }
    };
    return trigger;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGhyb3R0bGUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvdGhyb3R0bGUudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsTUFBTSxVQUFVLFFBQVEsQ0FDdkIsRUFBd0IsRUFDeEIsS0FBYTtJQUViLElBQUksT0FBTyxHQUF5QyxJQUFJLENBQUE7SUFDeEQsSUFBSSxRQUFRLEdBQWEsSUFBSSxDQUFBO0lBQzdCLE1BQU0sT0FBTyxHQUFHLENBQUMsR0FBRyxJQUFPLEVBQUUsRUFBRTtRQUM5QixJQUFJLE9BQU8sS0FBSyxJQUFJLEVBQUUsQ0FBQztZQUN0QixRQUFRLEdBQUcsSUFBSSxDQUFBO1lBQ2YsT0FBTyxHQUFHLFVBQVUsQ0FBQyxHQUFHLEVBQUU7Z0JBQ3pCLE9BQU8sR0FBRyxJQUFJLENBQUE7Z0JBQ2QsSUFBSSxRQUFRO29CQUFFLE9BQU8sQ0FBQyxHQUFHLFFBQVEsQ0FBQyxDQUFBO1lBQ25DLENBQUMsRUFBRSxLQUFLLENBQUMsQ0FBQTtZQUNULEVBQUUsQ0FBQyxHQUFHLElBQUksQ0FBQyxDQUFBO1FBQ1osQ0FBQzthQUFNLENBQUM7WUFDUCxRQUFRLEdBQUcsSUFBSSxDQUFBO1FBQ2hCLENBQUM7SUFDRixDQUFDLENBQUE7SUFDRCxPQUFPLE9BQU8sQ0FBQTtBQUNmLENBQUMifQ==